
$(function() {
  $('.menu-drawer__menu details summary').on('click', function(e) {
    e.preventDefault();

    var $summary = $(this);
    var $details = $summary.closest('details');
    var $submenu = $summary.next('.menu-drawer__submenu');
    if ($submenu.is(':animated')) return;

    if ($details.attr('open')) {
      $submenu.slideUp(300, function() {
        $details.removeAttr('open');
        $details.removeClass('menu-opening');
        $summary.attr('aria-expanded', 'false');
        $submenu.css('display', '');
      });
    } else {
      $details.attr('open', 'open');
      $details.addClass('menu-opening');
      $summary.attr('aria-expanded', 'true');
      $submenu.hide().slideDown(300);
    }
  });
});

/**
 * footer accordion
 * - 749px以下で発火
 */
$(function() {
  $('.footer-nav__title[data-accordion]').on('click', function() {
    if ($(window).width() <= 749) {
      $(this).toggleClass('is-open');
      $(this).next('.footer-nav__list').slideToggle(300);
    }
  });
  $(window).on('resize', function() {
    if ($(window).width() > 749) {
      $('.footer-nav__list').removeAttr('style');
      $('.footer-nav__title[data-accordion]').removeClass('is-open');
    }
  });
});


/**
 * スクロール
 * - 通常＋外部ページからのハッシュ付きアクセス時にも対応
 */
$(function() {
  $('body').on('click', '.js-smooth', function() {
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, 550, "swing");
    return false;
  });
});
$(window).on('load', function(){
  if(location.hash){
    var target = $(location.hash);
    if(target.length){
      var position = target.offset().top - 75;
      $('html,body').scrollTop(position);
    }
  }
});

/**
 * ヒーローエリア　アニメーション
 * - 読み込みが完了したらクラスを付与
 */
window.addEventListener('load', () => {
  const heroImage = document.querySelector('.bg_image');
  if (heroImage) {
    heroImage.classList.add('is-loaded');
  }
});